module.exports = __webpack_public_path__ + "static/media/36-15.7ac639ac.mp3";